import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltip][appOverflowTooltip]',
  standalone: true,
})
export class OverflowTooltipDirective {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly tooltip = inject(MatTooltip);

  constructor() {
    this.tooltip.disabled = true;
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.showIfOverflow();
  }

  @HostListener('focusin')
  onFocusIn() {
    this.showIfOverflow();
  }

  @HostListener('touchstart')
  onTouchStart() {
    this.showIfOverflow();
  }

  private showIfOverflow() {
    const element = this.elementRef.nativeElement;
    this.tooltip.disabled = element.scrollWidth <= element.clientWidth;
    if (!this.tooltip.disabled) {
      this.tooltip.show();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.hideTooltip();
  }

  @HostListener('focusout')
  onFocusOut() {
    this.hideTooltip();
  }

  @HostListener('touchend')
  onTouchEnd() {
    this.hideTooltip();
  }

  @HostListener('touchcancel')
  onTouchCancel() {
    this.hideTooltip();
  }

  private hideTooltip() {
    this.tooltip.hide();
    this.tooltip.disabled = true;
  }
}
